import React from "react";
import ReactDOM from "react-dom";
import {Provider} from "mobx-react";
import {hashHistory, IndexRoute, Route, Router} from "react-router";
import {RouterStore, syncHistoryWithStore} from "mobx-react-router";

// Stores
import AuthStore from "./stores/AuthStore";
import ConfigStore from "./stores/ConfigStore";
import DropboxStore from "./stores/DropboxStore";
import StudentStore from "./stores/StudentStore";
import PlayerStore from "./stores/PlayerStore";
import GameStore from "./stores/GameStore";
import Game2Store from "./stores/Game2Store";
import Game3Store from "./stores/Game3Store";
import Game4Store from "./stores/Game4Store";
import SchoolStore from "./stores/SchoolStore";
import ProductStore from "./stores/ProductStore";

// Visual Components
import App from "./App";
import Login from "./containers/Login";
import Home from "./containers/Home";
import Library from "./containers/Library";
import Eboard from "./containers/Eboard";
import EngagementReport from "./containers/EngagementReport";
import ClassReport from "./containers/ClassReport";
import QrcodeScan from "./containers/QrcodeScan";
import SearchStudent from "./containers/SearchStudent";
import EngagementStudent from "./containers/EngagementStudent";
import Player from "./containers/Player";
import Games from "./containers/Games";
import Game from "./containers/Game";
import Game2 from "./containers/Game2";
import Game3 from "./containers/Game3";
import Rocket from "./containers/Rocket";

// stylesheets
import "normalize.css";
import Game4 from "./containers/Game4/Game4";

// Monitoring
import ErrorLogger from './utils/errorLogger'

// API Integration
import { setProductStore } from './utils/api';

// Rotas
const Navigator = new RouterStore();

// Sync history with web store
const history = syncHistoryWithStore(hashHistory, Navigator);

// Stores
const stores = {
    AuthStore,
    Navigator,
    ConfigStore,
    DropboxStore,
    StudentStore,
    PlayerStore,
    SchoolStore,
    GameStore,
    Game2Store,
    Game3Store,
    Game4Store,
    ProductStore
};

// CheckAuth
const checkAuth = (nextState, replace) => {
    stores.SchoolStore.msgAttendance = "";

    if (!AuthStore.checkAuth) {
        replace('/login');
    }
};

const checkAuthAndProduct = (nextState, replace) => {
    checkAuth(nextState, replace);

    if (!AuthStore.checkAuth) {
        return;
    }

    if (ProductStore.mustSelectProduct) {
        replace('/');
    }
};

const resetAttendanceMsg = () => {
    stores.SchoolStore.msgAttendance = "";
}

ErrorLogger.init();

// Setup API with ProductStore
setProductStore(ProductStore);

ReactDOM.render(
    <Provider {...stores}>
        <Router history={history}>
            <Route path='/' component={App}>
                <IndexRoute onEnter={checkAuth} component={Home} />
                <Route path='login' onEnter={resetAttendanceMsg} component={Login} />
                <Route path='library' onEnter={checkAuthAndProduct} component={Library} />
                <Route path='games' onEnter={resetAttendanceMsg} component={Games} />
                <Route path='game' onEnter={resetAttendanceMsg} component={Game} />
                <Route path='game2' onEnter={resetAttendanceMsg} component={Game2} />
                <Route path='game3' onEnter={resetAttendanceMsg} component={Game3} />
                <Route path='game4' onEnter={resetAttendanceMsg} component={Game4} />
                <Route path='eboard' onEnter={checkAuthAndProduct} component={Eboard}/>
                <Route path='player' onEnter={checkAuthAndProduct} component={Player}/>
                <Route path='engagement-report' onEnter={checkAuthAndProduct} component={EngagementReport} />
                <Route path='class-report' onEnter={checkAuthAndProduct} component={ClassReport} />
                <Route path='rocket' onEnter={checkAuthAndProduct} component={Rocket} />
                <Route path='qrcode-scan' onEnter={checkAuthAndProduct} component={QrcodeScan} />
                <Route path='search' onEnter={checkAuthAndProduct} component={SearchStudent} />
                <Route path='search/:searchStudent' onEnter={checkAuthAndProduct} component={SearchStudent} />
                <Route path='detail-student/:studentId' onEnter={checkAuthAndProduct} component={SearchStudent} />
                <Route path='search-result/:studentId' onEnter={checkAuthAndProduct} component={SearchStudent} />
                <Route path='engagement-student/:studentId' onEnter={checkAuthAndProduct} component={EngagementStudent} />
            </Route>

            <Route path='*' onEnter={resetAttendanceMsg} component={Login} />
        </Router>
    </Provider>
    ,
    document.getElementById('root')
);


// WEBPACK FOOTER //
// ./src/index.js